import React from "react";
import BackHeader from "@components/header/BackHeader";
import TabWithPanel from "@components/tab/TabWithPanel";
import styled from "@emotion/styled";
import { Activity, News } from "@pages/alarm/index";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const Alarm = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const defaultValue = location.state?.activeTab || "1";

  const item = [
    {
      label: t("활동"),
      key: "1",
      children: <Activity />,
    },
    {
      label: t("새소식"),
      key: "2",
      children: <News />,
    },
  ];

  return (
    <div>
      <BackHeader title="알림" />

      <Container>
        <TabWithPanel item={item} defaultValue={defaultValue} />
      </Container>
    </div>
  );
};

export default Alarm;
